import React, { useEffect, useState } from 'react';
import PlaceholderLoading from 'react-placeholder-loading';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import Image from '../components/Image';
import type { Recipe } from '../types/recipes';
import { getCategoryName } from '../utils/categories';
import { shuffleArray } from '../utils/helpers';

const Header = styled.div`
  background: #b0d9f9;
  color: #272b46;
  display: flex;
  justify-content: center;
  padding-top: 20px;
`;
const Container = styled.div`
  background: #b0d9f9;
  color: #272b46;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px;
  @media screen and (max-width: 900px) {
    padding: 8px 0;
  }
`;
const Result = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin: 8px;
  padding: 8px;
  text-align: center;
  align-items: center;
  width: 150px;
  @media screen and (max-width: 900px) {
    width: 140px;
  }

  :hover {
    box-shadow: 0 0 3px 2px #272b46;
  }
`;
const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 150px;
  overflow: hidden;
`;
const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 8px;
  padding: 8px;
  align-items: center;
  width: 150px;
  max-height: 150px;
  @media screen and (max-width: 900px) {
    width: 140px;
  }
`;

const CategoryPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [recipes, setRecipes] = useState<Array<Recipe>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`/api/recipes?category=${id}`)
      .then((response) => response.json())
      .then((data) => {
        setRecipes(shuffleArray(data));
        setLoading(false);
      });
  }, [id]);

  return (
    <>
      <Header>
        <h1>Recipes in "{getCategoryName(id || '')}"</h1>
      </Header>
      <Container>
        {loading &&
          Array.from({ length: 10 }).map((_, index) => {
            return (
              <Placeholder key={index}>
                <PlaceholderLoading
                  shape="rect"
                  width={140}
                  height={100}
                  colorStart="#e0e0e0"
                  colorEnd="#d0d0d0"
                />
                <PlaceholderLoading
                  shape="rect"
                  width={130}
                  height={12}
                  colorStart="#e0e0e0"
                  colorEnd="#d0d0d0"
                />
              </Placeholder>
            );
          })}
        {!loading &&
          recipes.map((recipe) => {
            return (
              <Result onClick={() => navigate(`/recipe/${recipe._id}`)}>
                <ImageContainer>
                  <Image recipe={recipe} width={recipe.imageId ? 150 : 100} />
                </ImageContainer>
                <span>{recipe.name}</span>
              </Result>
            );
          })}
      </Container>
    </>
  );
};

export default CategoryPage;
